import React from 'react';
import StopDetailsModal from 'react/containers/modals/StopDetails';
import { checkAndUnmountComponentByNode, renderComponent } from 'react/utils/renderUtils';

Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.StopSelection = function(routeId) {

    const map = Monet.Session.RouteDetail.screensList[routeId].map;

    this.selectOrDeselectStop = function (stopId) {
        const marker = this.findStopMarker(stopId);

        if (!marker?.selected) {
            const currentSelectedStopId = this.findCurrentSelectedStopId();
            if (currentSelectedStopId) {
                this.deselectStop(this.findStopMarker(currentSelectedStopId), true);
            }
            else {
                //remove stop radius and expanded stop radius layers if they are checked to be shown
                const stopRadius = new Greenmile.RouteDetail.StopRadius(map, routeId);
                const deliveryRadiusCheckbox = document.querySelector(`#routeMaps_${routeId} #radius_route-route-${routeId}`);
                const deliveryExpandedRadiusCheckbox = document.querySelector(`#expanded_radius_route-route-${routeId}`);

                if (deliveryRadiusCheckbox && deliveryRadiusCheckbox.checked) {
                    stopRadius.removePositionRadius();
                }

                if (deliveryExpandedRadiusCheckbox && deliveryExpandedRadiusCheckbox.checked) {
                    stopRadius.removePositionExpandedRadius();
                }
            }
            this.selectStop(stopId, marker);
        }
    };

    this.selectStop = function (stopId, marker) {
        if (marker && !marker.selected) {
            marker.selected = true;
            this.showStopDetailsPopup(stopId, marker);

            this.setCurrentSelectedStopId(stopId);
            const stop = Monet.Session.RouteDetail.screensList[routeId].markerStops.getById(stopId).get('stop');

            const stopRadius = new Greenmile.RouteDetail.StopRadius(map, routeId);
            stopRadius.checkDeliveryRadiusInLocation(stop);
            stopRadius.checkDeliveryExpandedRadiusInLocation(stop);
            this.updateStopMarkerOnMap(marker);
        }
    };

    this.deselectStop = function (marker, doNotRestoreRadius) {
        if (!marker) {
            marker = this.findStopMarker(this.findCurrentSelectedStopId());
        }
        if (marker) {
            marker.selected = false;
        }
        this.setCurrentSelectedStopId(null);
        //remove all stop radius and expanded stop radius on map
        const stopRadius = new Greenmile.RouteDetail.StopRadius(map, routeId);
        stopRadius.removePositionRadius();
        stopRadius.removePositionExpandedRadius();

        if (!doNotRestoreRadius) {
            this.restoreStopRadiusLayers();
        }

        this.updateStopMarkerOnMap(marker);
    },

    //find a stop marker by its ID, reminder: markers are layers on the map
    this.findStopMarker = function (stopId) {
        const layers = map._layers;
        for (let key in layers) {
            let layer = layers[key];
            if (layer.id === stopId && layer.kind === 'STOP'){
                return layer;
            }
        }
        return {};
    },

    this.updateStopMarkerOnMap = function (marker) {
      const layers = map._layers;
      for (let key in layers) {
          let layer = layers[key];
          if (layer.id === marker.id && layer.kind === 'STOP'){
              layers[key] = marker;
              break;
          }
      }
    }

    //find current selected stop on map and return its ID, reminder: markers' IDs are equal to stops' IDs
    this.findCurrentSelectedStopId = function () {
        return Monet.Session.RouteDetail.screensList[routeId].selectedStopId;
    },

    this.setCurrentSelectedStopId = function(stopId) {
        Monet.Session.RouteDetail.screensList[routeId].selectedStopId = stopId;
    },

    this.restoreStopRadiusLayers = function () {
        const stopRadius = new Greenmile.RouteDetail.StopRadius(map, routeId);
        const deliveryRadiusCheckbox = document.querySelector(`#routeMaps_${routeId} #radius_route-route-${routeId}`);
        const deliveryExpandedRadiusCheckbox = document.querySelector(`#expanded_radius_route-route-${routeId}`);

        if (deliveryRadiusCheckbox && deliveryRadiusCheckbox.checked) {
            stopRadius.drawRadiusFromStop();
        }
        if (deliveryExpandedRadiusCheckbox && deliveryExpandedRadiusCheckbox.checked) {
            stopRadius.drawExpandedRadiusFromStop();
        }
    },

    this.showStopDetailsPopup = function (stopId, marker) {

        const content = document.querySelector(`#routeMaps_${routeId} .containerRouteDetail #panelContainer #routeDetailsModalContent`);
        const panelContainer = content.parentElement;
        panelContainer.setAttribute('class', 'slide');
        const gridHidden = document.querySelector("#miniPlayer").style.display == "block";
        const permissions = Monet.Session.Security.permissions;

        const hasGeocodeListPermission = permissions.some(permission => permission.key === "SMARTGEOCODE_LIST");
        const hasGeocodeCreatePermission = permissions.some(permission => permission.key === "MASSIVESMARTGEOCODEPROCESS_CREATE");
        const hasEditLocationPermission = permissions.some(permission => permission.key === "LOCATION_UPDATE");

        if(gridHidden) {
            panelContainer.style.bottom = '63px';
        } else {
            const routeDetailGridHeight = document.querySelector("#tabsRouteDetail").style.height;
            const heightNumber = (parseInt(routeDetailGridHeight) || 35) + 10;
            panelContainer.style.bottom = `${heightNumber}px`;

        }

        checkAndUnmountComponentByNode(content);

        renderComponent(
          <StopDetailsModal
            index = {0}
            routeId = {routeId}
            stopId = {stopId}
            marker = {marker}
            map = {map}
            hasGeocodeListPermission = {hasGeocodeListPermission}
            hasGeocodeCreatePermission = {hasGeocodeCreatePermission}
            hasEditLocationPermission = {hasEditLocationPermission}
          />,
          content
        );
    };
};
